import api from 'services/api';
import { type Received } from 'validation';

import { auditTrailSchema, type AuditTrail } from 'api/shared/auditTrail';
import { readResponse } from 'api/shared/readResponse';

/**
 * GET `/zones/audit_trail/:name` — the zone's change history (newest first),
 * served by the backend's shared audit-trail helper (see api/shared/auditTrail).
 * Throws on transport error or structural validation failure; an entry whose
 * identity `audit_trail_id` drifted is dropped.
 */
export const getZoneAuditTrail = async (name: string): Promise<Received<AuditTrail>> => {
  const res = await api.get(`/zones/audit_trail/${encodeURIComponent(name)}`);
  return readResponse(res.data, { schema: auditTrailSchema, source: 'getZoneAuditTrail' });
};
